import { UseMutateAsyncFunction, useMutation } from 'react-query';

import {
  ClientLoginWithCodeRequestType,
  ClientLoginWithCodeResponseType
} from '../../../services/NwAuthServices/APIService/types';

import { useNwAuthAPIService } from '../useNwAuthAPIService';

function useGetCollegePredictorClientAuthDetails(): {
  getCollegePredictorClientAuthDetailsAPI: UseMutateAsyncFunction<
    ClientLoginWithCodeResponseType,
    unknown,
    ClientLoginWithCodeRequestType,
    unknown
  >;
  error;
  status;
} {
  const { nwAuthAPIService } = useNwAuthAPIService();

  const getAuthDetails = (requestObject: ClientLoginWithCodeRequestType) => {
    return nwAuthAPIService.onLogin(requestObject);
  };

  const { mutateAsync, error, status } = useMutation(getAuthDetails, {
    mutationKey: ['getCollegePredictorClientAuthDetails']
  });

  return {
    getCollegePredictorClientAuthDetailsAPI: mutateAsync,
    error,
    status
  };
}

export { useGetCollegePredictorClientAuthDetails };
